import { render, staticRenderFns } from "./SubscriptionCommunityPage.vue?vue&type=template&id=0c0028d8&"
import script from "./SubscriptionCommunityPage.vue?vue&type=script&lang=js&"
export * from "./SubscriptionCommunityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports